import window from 'common/window'

interface IExternalRedirectProps {
  to: string
}

const ExternalRedirect = ({ to }: IExternalRedirectProps) => {
  window.location.href = to
  return null
}

export default ExternalRedirect
